import type { FC, InputHTMLAttributes } from 'react';
import Input from '../../input/Input';
import { cn } from '../../../utils/cn';
import { FORM_ERROR_CLASS, FORM_LABEL_CLASS } from '../formControlStyles';

type FormFieldProps = {
    name: string;
    label: string;
    error?: string;
    showError?: boolean;
    className?: string;
    inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'name'>;
} & Pick<
    InputHTMLAttributes<HTMLInputElement>,
    'type' | 'value' | 'placeholder' | 'disabled' | 'onChange' | 'onBlur' | 'autoComplete'
>;

const FormField: FC<FormFieldProps> = ({
    name,
    label,
    error,
    showError = false,
    className,
    type = 'text',
    value,
    placeholder,
    disabled,
    onChange,
    onBlur,
    autoComplete,
    inputProps,
}) => {
    const hasError = showError && Boolean(error);

    return (
        <div className={cn('w-full', className)}>
            <label htmlFor={name} className={FORM_LABEL_CLASS}>
                {label}
            </label>
            <Input
                {...inputProps}
                id={name}
                name={name}
                type={type}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                autoComplete={autoComplete}
                hasError={hasError}
                aria-invalid={hasError}
            />
            {hasError ? (
                <p className={FORM_ERROR_CLASS} role="alert">
                    {error}
                </p>
            ) : null}
        </div>
    );
};

export default FormField;
